<template>
  <div class="animated fadeIn" id="hssk-page" v-loading="loading">
    <div class="card">
      <div class="card-header">
        Hồ sơ sức khỏe cá nhân 4210
        <div class="card-header-actions" v-if="!loading && !showMessageError">
          THỜI GIAN HIỆU LỰC: <span :class="warningColor ? 'red':'black'">{{ countDown }}</span>
        </div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataFormDoctor"
          :rules="mData.validFormDoctor"
          ref="myFormDoctor"
          label-width="100%"
          label-position="top"
          @submit.native.prevent
        >
          <b-row v-if="mData.showCardCode">
            <b-col md="4">
              <el-form-item label="Nhập mã thẻ" props="cardCode">
                <el-input
                  v-model.trim="mData.dataFormDoctor.cardCode"
                  clearable
                  placeholder="Nhấn enter để tìm kiếm"
                  @keyup.enter.native="
                    fn_getDotKhamByCardCode(
                      mData.dataFormDoctor.cardCode,
                      mData.token
                    )
                  "
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="2">
              <el-button
                class="noLabel"
                type="info"
                plain
                @click="
                  fn_getDotKhamByCardCode(
                    mData.dataFormDoctor.cardCode,
                    mData.token
                  )
                "
                >{{ aLang.c_detail }}</el-button
              >
            </b-col>
          </b-row>
        </el-form>
        <div style="text-align: center" v-if="showMessageError">
          <p style="margin-bottom: 0; font-weight: bold">
            THÔNG BÁO: HẾT HẠN PHIÊN LÀM VIỆC
          </p>
          <p style="font-weight: bold">
            VUI LÒNG LẤY LẠI THÔNG TIN TRÊN PHẦN MỀM
          </p>
        </div>
        <b-tabs
          v-model="mData.activeTab"
          @activate-tab="handleClick"
          v-if="!showMessageError"
        >
          <b-tab title="Đợt khám" active>
            <el-timeline class="mt-1">
              <el-timeline-item
                v-for="(item, index) in mData.listData"
                :key="index"
                color="#3598DC"
                icon="fa fa-stethoscope"
                size="large"
                :timestamp="
                  'Thời gian điều trị: ' +
                  (item.ngay_bat_dau != item.ngay_ket_thuc
                    ? item.ngay_bat_dau + ' - ' + item.ngay_ket_thuc
                    : item.ngay_bat_dau)
                "
                placement="top"
              >
                <b-row class="mt-2 ml-4">
                  <b-col md="12">
                    <span class="bold-500">Tên cơ sở:</span> {{ item.noi_kham }}
                  </b-col>
                  <b-col md="12">
                    <span class="bold-500">Khoa điều trị:</span>
                    {{ item.khoa_dieu_tri }}
                  </b-col>
                  <b-col md="12">
                    <span class="bold-500">Chẩn đoán bệnh:</span>
                    {{ item.ten_benh }}
                  </b-col>
                  <b-col md="12" class="mt-2">
                    <el-button
                      type="primary"
                      plain
                      @click="fn_checkViewDetail(item)"
                      >{{ aLang.c_detail }}</el-button
                    >
                  </b-col>
                </b-row>
              </el-timeline-item>
            </el-timeline>
          </b-tab>
          <!-- <b-tab title="Cận lâm sàng">
                        <b-row class="mb-2">
                            <b-col md="12">
                                <p v-if="
                        (mData.CanLamSang && mData.CanLamSang.length == 0) ||
                        !mData.CanLamSang
                      ">
                                    Không có dữ liệu!
                                </p>
                                <table border="1" cellspacing="0" cellpadding="8" width="100%" bordercolor="#777777" style="border-collapse: collapse" v-if="mData.CanLamSang && mData.CanLamSang.length > 0">
                                    <tr>
                                        <td class="bold-500" style="text-align: center">
                                            <span>STT</span>
                                        </td>
                                        <td class="bold-500" style="text-align: center">
                                            <span>Mã CSYT</span>
                                        </td>
                                        <td class="bold-500" style="text-align: center">
                                            <span>Tên bệnh nhân</span>
                                        </td>
                                        <td class="bold-500" style="text-align: center">
                                            <span>Giới tính</span>
                                        </td>
                                        <td class="bold-500" style="text-align: center">
                                            <span>Bộ phận cơ thể</span>
                                        </td>
                                        <td class="bold-500" style="text-align: center">
                                            <span>Thời gian</span>
                                        </td>
                                        <td class="bold-500" style="text-align: center">
                                            <span>Thao tác</span>
                                        </td>
                                    </tr>
                                    <tr v-for="(itemCanLamSang, index) in mData.CanLamSang" :key="index">
                                        <td style="text-align: center">
                                            <span>{{ index + 1 }}</span>
                                        </td>
                                        <td style="text-align: center">
                                            <span>{{ itemCanLamSang.HospitalAETitle }}</span>
                                        </td>
                                        <td style="text-align: center">
                                            <span>{{ itemCanLamSang.PatientName }}</span>
                                        </td>
                                        <td style="text-align: center">
                                            <span>{{
                            fn_changeGender(itemCanLamSang.PatientSex)
                          }}</span>
                                        </td>
                                        <td style="text-align: center">
                                            <span>{{ itemCanLamSang.BodyPart }}</span>
                                        </td>
                                        <td style="text-align: center">
                                            <span>{{
                            fn_formatDate(itemCanLamSang.ImageDateTime)
                          }}</span>
                                        </td>
                                        <td style="text-align: center">
                                            <el-button circle icon="el-icon-view" style="border: none" @click="fn_viewPacs(itemCanLamSang.URL)"></el-button>
                                        </td>
                                    </tr>
                                </table>
                            </b-col>
                        </b-row>
                    </b-tab> -->
        </b-tabs>
      </div>
    </div>

    <!-- modal chi tiet-->
    <el-dialog
      :title="
        'Chi tiết điều trị từ ngày ' +
        mData.dialogDetail.data.ngay_bat_dau +
        ' tại ' +
        mData.dialogDetail.data.noi_kham
      "
      :visible.sync="mData.dialogDetail.visibleDialog"
      width="70%"
      top="51px"
      append-to-body
      :close-on-click-modal="false"
    >
      <hssk-h-l7-form
        :prop-data-form="mData.dialogDetail"
        @changeData="changeData($event)"
      ></hssk-h-l7-form>
    </el-dialog>

    <!-- modal check quuyen-->
    <el-dialog
      :title="'Xin quyền truy cập'"
      :visible.sync="mData.dialogCheckQuyen.visibleDialog"
      width="50%"
      top="51px"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="card-body">
        <el-form
          :model="mData.dataFormCheckQuyen"
          :rules="mData.validFormCheckQuyen"
          ref="myForm"
          label-width="100%"
          label-position="top"
          @submit.native.prevent
        >
          <b-row>
            <b-col md="12" v-if="mData.dataFormCheckQuyen.status == 'chuaGui'"
              >Bấm gửi mã OTP để gửi mã tới điện thoại của bệnh nhân</b-col
            >
          </b-row>

          <b-row v-if="mData.dataFormCheckQuyen.status == 'choXacNhan'">
            <b-col md="12" class="mb-2">
              Đã gửi thành công tới số điện thoại:
              {{ mData.dataFormCheckQuyen.mobile }} <br />Yêu cầu bệnh nhân đọc
              mã OTP để được cấp quyền truy cập
            </b-col>
            <b-col md="6">
              <el-form-item
                label
                prop="otp"
                class="mb-1"
                :rules="mData.ruleOTP"
              >
                <el-input
                  v-model.trim="mData.dataFormCheckQuyen.otp"
                  clearable
                  placeholder="Nhập mã OTP"
                  type="otp"
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>

          <b-row>
            <b-col
              md="12"
              v-if="mData.dataFormCheckQuyen.status == 'guiKhongThanhCong'"
              >Gửi mã OTP đến số
              {{
                mData.dataFormCheckQuyen.mobile
                  ? mData.dataFormCheckQuyen.mobile
                  : "điện thoại"
              }}
              không thành công</b-col
            >
          </b-row>

          <b-row>
            <b-col
              md="12"
              v-if="mData.dataFormCheckQuyen.status == 'xacNhanKhongThanhCong'"
              >Mã OTP không đúng hoặc đã hết hạn</b-col
            >
          </b-row>

          <b-row>
            <!-- <b-col
              md="12"
              v-if="mData.dataFormCheckQuyen.status == 'xacNhanThanhCong'"
              >Bạn đã được cấp quyền xem y bạ điện tử của mã thẻ
              {{ mData.dataFormDoctor.cardCode }} trong vòng 24 giờ</b-col
            > -->
            <b-col
              md="12"
              v-if="mData.dataFormCheckQuyen.status == 'xacNhanThanhCong'"
              >Bạn đã được cấp quyền xem y bạ điện tử.</b-col
            >
          </b-row>

          <b-row>
            <b-col md="12" class="text-center mt-3">
              <el-button
                v-if="mData.dataFormCheckQuyen.status == 'chuaGui'"
                type="info"
                plain
                @click="fn_sendCode()"
                native-type="submit"
                >Gửi mã OTP</el-button
              >

              <el-button
                v-if="mData.dataFormCheckQuyen.status == 'choXacNhan'"
                type="info"
                plain
                @click="fn_confirmCode()"
                native-type="submit"
                >Xác nhận</el-button
              >

              <el-button
                v-if="
                  mData.dataFormCheckQuyen.status == 'xacNhanKhongThanhCong'
                "
                type="info"
                plain
                @click="fn_sendCodeAgain()"
                >Gửi lại</el-button
              >

              <el-button
                v-if="mData.dataFormCheckQuyen.status == 'guiKhongThanhCong'"
                type="info"
                plain
                @click="fn_backSendCode()"
                >{{ aLang.c_back }}</el-button
              >

              <el-button
                v-if="mData.dataFormCheckQuyen.status == 'xacNhanThanhCong'"
                type="info"
                plain
                @click="fn_continue()"
                >Tiếp tục</el-button
              >

              <el-button
                @click="mData.dialogCheckQuyen.visibleDialog = false"
                type="info"
                plain
                >{{ aLang.c_close }}</el-button
              >
            </b-col>
          </b-row>
        </el-form>
      </div>
    </el-dialog>

    <el-dialog
      :title="'Chi tiết kết quả ngày ' + mData.dialogDetail.dateSelect"
      :visible.sync="mData.dialogDetail.visibleDialogXN"
      width="70%"
      top="51px"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="card-body p-0">
        <b-col md="12" class="p-0">
          <b-tabs
            card
            pills
            vertical
            width="100%"
            nav-wrapper-class="w-40"
            v-model="tabIndex[1]"
          >
            <b-tab active style="max-height: 80vh; overflow: auto">
              <div
                v-if="mData.dialogDetail.dataXetNghiem[0].table.length == 0"
                class="text-center"
              >
                <span>Không có thông tin xét nghiệm</span>
              </div>
              <template slot="title">Xét nghiệm</template>
              <!-- <template> -->
              <el-table
                :data="mData.dialogDetail.dataXetNghiem[0].table"
                :span-method="objectSpanMethod"
                border
                style="width: 100%"
                v-if="mData.dialogDetail.dataXetNghiem[0].table.length > 0"
              >
                <el-table-column label="Tên dịch vụ">
                  <template slot-scope="scope">
                    <div>
                      <p style="white-space: normal; margin-bottom: 0px">
                        {{ scope.row.service_name }}
                      </p>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="Tên tiêu chí">
                  <template slot-scope="scope">
                    <div>
                      <p style="white-space: normal; margin-bottom: 0px">
                        {{ scope.row.criteria_name }}
                      </p>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column label="Mô tả" min-width="200px">
                  <template slot-scope="scope">
                    <div>
                      <p style="white-space: normal; margin-bottom: 0px">
                        {{ scope.row.mo_ta }}
                      </p>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column label="Đơn vị">
                  <template slot-scope="scope">
                    <div class="text-center">
                      {{ scope.row.unit }}
                    </div>
                  </template>
                </el-table-column>

                <el-table-column label="Kết quả">
                  <template slot-scope="scope">
                    <div class="text-center">
                      {{ scope.row.result }}
                    </div>
                  </template>
                </el-table-column>

                <el-table-column label="Kết quả bình thường">
                  <template slot-scope="scope">
                    <div class="text-center">
                      {{ scope.row.result_ }}
                    </div>
                  </template>
                </el-table-column>

                <el-table-column label="Kết luận">
                  <template slot-scope="scope">
                    <div>
                      <p style="white-space: normal; margin-bottom: 0px">
                        {{ scope.row.ket_luan }}
                      </p>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <!-- </template> -->
            </b-tab>
            <b-tab style="max-height: 80vh; overflow: auto">
              <div
                v-if="mData.dialogDetail.dataOther.length == 0"
                class="text-center"
              >
                <span>Không có thông tin</span>
              </div>
              <template slot="title">Khác</template>
              <el-timeline class="mt-1">
                <el-timeline-item
                  v-for="(item, index) in mData.dialogDetail.dataOther"
                  :key="index"
                  color="#3598DC"
                  size="large"
                  placement="top"
                >
                  <b-row class="mt-2 ml-3">
                    <b-col md="12">
                      <b-col md="12" class="mt-2">
                        <span class="bold-500">Dịch vụ:</span>
                        <p
                          style="white-space: pre-line"
                          v-if="item.service_name"
                        >
                          {{ `${item.service_name || ""}` }}
                        </p>
                      </b-col>
                      <b-col md="12" class="pb-2">
                        <span class="bold-500">Mô tả:</span>
                        <p
                          style="white-space: pre-line"
                          v-if="item.description"
                        >
                          {{ `${item.description}` }}
                        </p>
                      </b-col>
                      <b-col md="12" class="pb-2">
                        <span class="bold-500">Kết luận:</span>
                        <p style="white-space: pre-line" v-if="item.result">
                          {{ `${item.result}` }}
                        </p>
                      </b-col>
                    </b-col>
                  </b-row>
                </el-timeline-item>
              </el-timeline>
            </b-tab>
          </b-tabs>
        </b-col>
      </div>
    </el-dialog>

    <!-- Popup Pacs -->
    <div
      id="pacs-views"
      style="
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 2000;
      "
      v-show="mData.showPacs"
    >
      <iframe
        :src="mData.urlPacs"
        frameborder="0"
        width="100%"
        height="100%"
      ></iframe>
      <el-button
        icon="el-icon-close"
        type="danger"
        @click="mData.showPacs = !mData.showPacs"
        style="
          position: absolute;
          right: 0.5rem;
          top: 0.5rem;
          font-size: 1.2rem;
        "
        circle
      ></el-button>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
// import Hssk4210Api from "../../../moduleApi/Hssk4210Api";
import HsskHL7Api from "../../../moduleApi/HsskHL7ApiAxios";
import HsskHL7Model from "./Hssk4210Model";
import HsskHL7Form from "./Hssk4210Form";
import AuthService from "./../../../service/AuthService";
import ValidService from "../../../service/ValidService";
import moment from "moment";
import { Buffer } from "buffer";
var NProgress = require("nprogress");

export default {
  components: { HsskHL7Form },
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        token: "",
        moduleName: "Hssk4210", //requied
        listData: [],
        queryData: {},
        dataFormDoctor: MethodService.copyObject(HsskHL7Model.dataFormDoctor),
        validFormDoctor: MethodService.copyObject(HsskHL7Model.validFormDoctor),

        validFormCheckQuyen: MethodService.copyObject(
          HsskHL7Model.validFormCheckQuyen
        ),
        dataFormCheckQuyen: MethodService.copyObject(
          HsskHL7Model.dataFormCheckQuyen
        ),

        showCardCode: false,
        actived: [],
        dialogDetail: {
          visibleDialog: false,
          visibleDialogXN: false,
          data: MethodService.copyObject(HsskHL7Model.dataModalDetail),
          dataTabAll: null,
          cardCode: "",
          dataXetNghiem: [
            {
              table: [],
            },
          ],
          dataOther: [],
          dateSelect: "",
          dataMergeCol:[]
        },
        dialogCheckQuyen: {
          visibleDialog: false,
          status: "xacNhanThanhCong",
        },
        activeTab: 0,
        CanLamSang: [],
        showPacs: false,
        urlPacs: "",
        haveData: false,
        getPacs: false,
        ruleOTP: [ValidService.required, ValidService.checkNumber],
      },
      tabIndex: [0, 0],
      loading: true,
      showMessageError: false,
      countDown: "",
      warningColor: false 
    };
  },

  methods: {
    changeData(data) {
      let dataXetNghiem = [];
      let dataOther = [];
      data.result_data.forEach((element) => {
        if (element.type_service == "Xét nghiệm") {
          dataXetNghiem.push(element);
        } else {
          dataOther.push(element);
        }
      });
      if (dataXetNghiem.length > 0) {
        dataXetNghiem[0].table = dataXetNghiem[0].table.sort(function (a, b) {
          return a.service_name.localeCompare(b.service_name);
        });

        let dataMergeCol = [];
        dataXetNghiem[0].table.forEach((elXN, index) => {
          let findXN = dataMergeCol.find((el) => el.key == elXN.service_name);
          if (!findXN) {
            let data = {
              key: elXN.service_name,
              count: 1,
              rowIndex: index,
            };
            dataMergeCol.push(data);
          } else {
            let findIndex = dataMergeCol.findIndex(
              (elMerge) => elMerge.key == findXN.key
            );
            dataMergeCol[findIndex].count += 1;
          }
        });
        this.mData.dialogDetail.dataMergeCol = dataMergeCol;
      }
      this.mData.dialogDetail.dataXetNghiem =
        dataXetNghiem.length > 0 ? dataXetNghiem : [{ table: [] }];
      this.mData.dialogDetail.dataOther = dataOther;
      this.mData.dialogDetail.dateSelect = data.date;
      this.mData.dialogDetail.visibleDialogXN = true;
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (this.mData.dialogDetail.dataMergeCol.length > 0) {
          let find = this.mData.dialogDetail.dataMergeCol.find(
            el => el.rowIndex == rowIndex
          );
          if (find) {
            return {
              rowspan: find.count,
              colspan: 1,
            }
          }else{
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
        }
      }
    },
    fn_getTime(day) {
      if (!day) {
        return 0;
      }
      return new Date(
        day.substring(6, 10),
        parseInt(day.substring(3, 5)) - 1,
        day.substring(0, 2),
        day.substring(11, 13),
        day.substring(14, 16)
      ).getTime();
    },

    fn_convertTimeRequet(day) {
      let time = `${day.substring(0, 4)}-${day.substring(4, 6)}-${day.substring(
        6,
        8
      )} ${day.substring(8, 10)}:${day.substring(10, 12)}:${day.substring(
        12,
        14
      )}`;
      return new Date(time).getTime();
    },
    fn_setTimeOut(timeOut){
      this.countDown = this.countDownTime(timeOut);
      window.timeoutCoundown = setTimeout(() => {
      let timeOut1 =
              24 * 60 * 60 * 1000 -
              (new Date().getTime() -
                this.fn_convertTimeRequet(this.mData.queryData.date));
        this.fn_setTimeOut(timeOut1);
      }, 1000);
    },
    async fn_initData() {
      // window.localStorage.setItem("activedOTPHis", {});
      try {
        let auth = await HsskHL7Api.loginBSBiin();
        this.mData.token = auth.data.result.token;
      } catch (error) {
        this.$router.push("/404");
      }
      try {
        if (this.$router.currentRoute.query.cardCode) {
          setTimeout(() => {
            NProgress.start();
            $("body").css("pointer-events", "none");
          }, 200);
          this.mData.dataFormDoctor.cardCode =
            this.$router.currentRoute.query.cardCode;
          this.mData.showCardCode = false;
          await this.fn_getDotKhamByCardCode(
            this.mData.dataFormDoctor.cardCode,
            this.mData.token
          );
          this.loading = false;
        } else if (this.$router.currentRoute.query.param) {
          let data = Buffer(
            this.$router.currentRoute.query.param,
            "base64"
          ).toString();
          let array = data.split("&");
          array.forEach((string) => {
            let cache = string.split("=");
            if (cache.length == 2) {
              this.mData.queryData[cache[0]] = cache[1];
            }
          });
          if (Object.keys(this.mData.queryData).length == 0) {
            this.loading = false;
            toastr.warning("Thông tin không chính xác!");
            return;
          }
          if (
            this.mData.queryData.date &&
            new Date().getTime() -
              this.fn_convertTimeRequet(this.mData.queryData.date) <
              24 * 60 * 60 * 1000
          ) {
            let body = {
              HoTen: this.mData.queryData.HoTen
                ? this.mData.queryData.HoTen
                : "",
              NgaySinh: this.mData.queryData.NgaySinh
                ? this.mData.queryData.NgaySinh
                : "",
              GioiTinh: this.mData.queryData.GioiTinh
                ? this.mData.queryData.GioiTinh
                : "",
              SoCMND: this.mData.queryData.SoCMND
                ? this.mData.queryData.SoCMND
                : "",
              SoTheBHYT: this.mData.queryData.SoTheBHYT
                ? this.mData.queryData.SoTheBHYT
                : "",
              DiaChi: this.mData.queryData.DiaChi
                ? this.mData.queryData.DiaChi
                : "",
              SoDienThoai: this.mData.queryData.SoDienThoai
                ? this.mData.queryData.SoDienThoai
                : "",
            };
            await this.fn_getDotKhamByTTHC(body, this.mData.token);
            this.loading = false;
            if (window.timeOutTimeRequest) {
              clearTimeout(window.timeOutTimeRequest);
            }
            if(window.timeoutCoundown){
              clearTimeout(window.timeoutCoundown);
            }
            let timeOut =
              24 * 60 * 60 * 1000 -
              (new Date().getTime() -
                this.fn_convertTimeRequet(this.mData.queryData.date));
            this.fn_setTimeOut(timeOut);
            window.timeOutTimeRequest = setTimeout(() => {
              // toastr.info("Hết phiên làm việc, vui lòng đăng nhập his");
              this.mData.dialogDetail.visibleDialog = false;
              this.mData.dialogCheckQuyen.visibleDialog = false;
              this.mData.dialogDetail.visibleDialogXN = false;
              this.showMessageError = true;
              return;
            }, timeOut);
          } else {
            this.loading = false;
            this.showMessageError = true;
            // toastr.info("Hết phiên làm việc, vui lòng đăng nhập his");
            return;
          }
        }
        if (window.localStorage.getItem("activedOTPHis")) {
          let cache = JSON.parse(window.localStorage.getItem("activedOTPHis"));
          if (cache["bs_biin"]) {
            // this.mData.actived = cache["bs_biin"].filter((card) => {
            //   return (
            //     new Date().getTime() - new Date(card.time).getTime() <
            //     24 * 60 * 60 * 1000
            //   );
            // });
            // this.mData.actived = cache["bs_biin"].filter((card) => {
            //   return (
            //     new Date().getTime() - new Date(card.time).getTime() <
            //     24 * 60 * 60 * 1000
            //   );
            // });
            this.mData.actived = cache["bs_biin"];
            if (this.mData.actived.length == 0) {
              delete cache["bs_biin"];
            } else {
              cache["bs_biin"] = this.mData.actived;
            }
            window.localStorage.setItem("activedOTPHis", JSON.stringify(cache));
          } else {
            this.mData.actived = [];
          }
        } else {
          this.mData.actived = [];
        }
      } catch (error) {
        this.loading = false;
      }
    },

    async fn_getDotKhamByCardCode(cardCode, token) {
      let res = await HsskHL7Api.listDotKham(cardCode, token);
      this.mData.listData = await this.fn_mergerDataHL7(res.data.result);
      this.mData.haveData = true;
    },

    async fn_getDotKhamByTTHC(data, token) {
      let res = await HsskHL7Api.listDotKhamByTTHC(data, token);
      this.mData.listData = await this.fn_mergerDataHL7ByTTHC(res.data.Data);
      // this.mData.haveData = true;
    },

    async fn_getPacs(cardCode, token) {
      if (cardCode) {
        try {
          let res = await HsskHL7Api.getPacs(cardCode, token);
          this.mData.CanLamSang = res.data.Data;
          this.mData.getPacs = true;
        } catch (error) {
          toastr.warn("Có lỗi xảy ra!");
        }
      } else if (Object.keys(this.mData.queryData).length > 0) {
        try {
          let body = {
            HoTen: this.mData.queryData.HoTen ? this.mData.queryData.HoTen : "",
            NgaySinh: this.mData.queryData.NgaySinh
              ? this.mData.queryData.NgaySinh
              : "",
            GioiTinh: this.mData.queryData.GioiTinh
              ? this.mData.queryData.GioiTinh
              : "",
            SoCMND: this.mData.queryData.SoCMND
              ? this.mData.queryData.SoCMND
              : "",
            SoTheBHYT: this.mData.queryData.SoTheBHYT
              ? this.mData.queryData.SoTheBHYT
              : "",
            DiaChi: this.mData.queryData.DiaChi
              ? this.mData.queryData.DiaChi
              : "",
            SoDienThoai: this.mData.queryData.SoDienThoai
              ? this.mData.queryData.SoDienThoai
              : "",
          };
          let res = await HsskHL7Api.getPacsByTTHC(body, token);
          this.mData.CanLamSang = res.data.Data;
          this.mData.getPacs = true;
        } catch (error) {
          toastr.warn("Có lỗi xảy ra!");
        }
      }
    },

    async handleClick(tab, prev, bvEvent) {
      if (tab == 1) {
        let phoneNumber = "";
        if (Object.keys(this.mData.queryData).length > 0) {
          if (!this.mData.queryData.SoDienThoai) {
            toastr.warning(
              "BN chưa khai báo số điện thoại, vui lòng xem kết quả kcb trên ứng dụng HSSK"
            );
            return;
          }
          phoneNumber = this.mData.queryData.SoDienThoai
            ? this.mData.queryData.SoDienThoai
            : "";
        }
        let cache = this.mData.actived.filter((card) => {
          return (
            card.cardCode == this.mData.dataFormDoctor.cardCode &&
            card.phoneNumber == phoneNumber &&
            new Date().getTime() - new Date(card.time).getTime() <
              24 * 60 * 60 * 1000
          );
        });
        if (cache.length == 0) {
          toastr.info("Bạn cần xin quyền truy cập");
          this.mData.dialogCheckQuyen.visibleDialog = true;
          this.fn_resetModal();
          bvEvent.preventDefault();
        } else if (!this.mData.getPacs) {
          await this.fn_getPacs(
            this.mData.dataFormDoctor.cardCode,
            this.mData.token
          );
        }
      }
    },

    fn_mergerDataHL7(data) {
      var arrNew = [];
      if (!data || data.length == 0 || data[0] == null) {
        toastr.info("Chưa có thông tin");
        this.mData.showCardCode = true;
        return;
      }
      // for sở
      data.forEach((el) => {
        if (el == null) return;
        if (
          !el.ApiResult.ThongTinVaoVien ||
          el.ApiResult.ThongTinVaoVien.length == 0
        ) {
          toastr.info("Chưa có thông tin");
          return;
        }
        el.ApiResult.ThongTinVaoVien.forEach((item) => {
          let obj = {
            id:
              item.Encounter && item.Encounter.IdElement
                ? item.Encounter.IdElement.Value
                : "",
            ma_noi_kham:
              item.Organization &&
              item.Organization.IdElement &&
              item.Organization.IdElement.Value
                ? item.Organization.IdElement.Value
                : "",
            noi_kham:
              item.Organization &&
              item.Organization.NameElement &&
              item.Organization.NameElement.Value
                ? item.Organization.NameElement.Value
                : "",
            ten_benh:
              item.Condition && item.Condition.Text && item.Condition.Text.Div
                ? item.Condition.Text.Div
                : "",
            ngay_bat_dau:
              item.Encounter &&
              item.Encounter.Period &&
              item.Encounter.Period.StartElement &&
              item.Encounter.Period.StartElement.Value
                ? MethodService.formatDate(
                    item.Encounter.Period.StartElement.Value,
                    "date"
                  )
                : "",
            ngay_ket_thuc:
              item.Encounter &&
              item.Encounter.Period &&
              item.Encounter.Period.EndElement &&
              item.Encounter.Period.EndElement.Value
                ? MethodService.formatDate(
                    item.Encounter.Period.EndElement.Value,
                    "date"
                  )
                : "",
            ngay_ket_thuc_date:
              item.Encounter &&
              item.Encounter.Period &&
              item.Encounter.Period.EndElement &&
              item.Encounter.Period.EndElement.Value
                ? item.Encounter.Period.EndElement.Value
                : null,
            khoa_dieu_tri:
              item.Location &&
              item.Location.NameElement &&
              item.Location.NameElement.Value
                ? item.Location.NameElement.Value
                : "",
            kieu_dich_vu:
              item.Encounter &&
              item.Encounter.ServiceType &&
              item.Encounter.ServiceType.Coding &&
              item.Encounter.ServiceType.Coding.length > 0 &&
              item.Encounter.ServiceType.Coding[0].CodeElement &&
              item.Encounter.ServiceType.Coding[0].CodeElement.Value
                ? item.Encounter.ServiceType.Coding[0].CodeElement.Value
                : "",
            so_ngay_kcb:
              item.Encounter &&
              item.Encounter.Length &&
              item.Encounter.Length.ValueElement &&
              item.Encounter.Length.ValueElement.Value
                ? item.Encounter.Length.ValueElement.Value
                : "",
            tinh_trang_ra_vien: this.hanleTinhTrangRaVien(item),
            danh_sach_benh: this.handleDanhSachBenh(item),
            danh_sach_benh_kem_theo: this.handleDanhSachBenh(item, true),
            danh_sach_cchn_bac_si: this.handleDanhSachCCHN(item),
          };

          arrNew.push(obj);
        });
      });
      let this_ = this;
      arrNew = arrNew.sort(function (a, b) {
        return (
          new Date(
            b.ngay_bat_dau.substring(6, 10),
            parseInt(b.ngay_bat_dau.substring(3, 5)) - 1,
            b.ngay_bat_dau.substring(0, 2)
          ).getTime() -
          new Date(
            a.ngay_bat_dau.substring(6, 10),
            parseInt(a.ngay_bat_dau.substring(3, 5)) - 1,
            a.ngay_bat_dau.substring(0, 2)
          ).getTime()
        );
      });

      return arrNew;
    },

    fn_mergerDataHL7ByTTHC(data) {
      var arrNew = [];
      if (!data) {
        toastr.info("Chưa có thông tin");
        this.mData.showCardCode = true;
        return;
      }
      // for sở
      if (!data.ThongTinVaoVien || data.ThongTinVaoVien.length == 0) {
        toastr.info("Chưa có thông tin");
        return;
      }
      data.ThongTinVaoVien.forEach((item) => {
        let obj = {
          id:
            item.Encounter && item.Encounter.IdElement
              ? item.Encounter.IdElement.Value
              : "",
          ma_noi_kham:
            item.Organization &&
            item.Organization.IdElement &&
            item.Organization.IdElement.Value
              ? item.Organization.IdElement.Value
              : "",
          noi_kham:
            item.Organization &&
            item.Organization.NameElement &&
            item.Organization.NameElement.Value
              ? item.Organization.NameElement.Value
              : "",
          ten_benh:
            item.Condition && item.Condition.Text && item.Condition.Text.Div
              ? item.Condition.Text.Div
              : "",
          ngay_bat_dau:
            item.Encounter &&
            item.Encounter.Period &&
            item.Encounter.Period.StartElement &&
            item.Encounter.Period.StartElement.Value
              ? MethodService.formatDate(
                  item.Encounter.Period.StartElement.Value,
                  "date"
                )
              : "",
          ngay_ket_thuc:
            item.Encounter &&
            item.Encounter.Period &&
            item.Encounter.Period.EndElement &&
            item.Encounter.Period.EndElement.Value
              ? MethodService.formatDate(
                  item.Encounter.Period.EndElement.Value,
                  "date"
                )
              : "",
          ngay_ket_thuc_date:
            item.Encounter &&
            item.Encounter.Period &&
            item.Encounter.Period.EndElement &&
            item.Encounter.Period.EndElement.Value
              ? item.Encounter.Period.EndElement.Value
              : null,
          khoa_dieu_tri:
            item.Location &&
            item.Location.NameElement &&
            item.Location.NameElement.Value
              ? item.Location.NameElement.Value
              : "",
          kieu_dich_vu:
            item.Encounter &&
            item.Encounter.ServiceType &&
            item.Encounter.ServiceType.Coding &&
            item.Encounter.ServiceType.Coding.length > 0 &&
            item.Encounter.ServiceType.Coding[0].CodeElement &&
            item.Encounter.ServiceType.Coding[0].CodeElement.Value
              ? item.Encounter.ServiceType.Coding[0].CodeElement.Value
              : "",
          so_ngay_kcb:
            item.Encounter &&
            item.Encounter.Length &&
            item.Encounter.Length.ValueElement &&
            item.Encounter.Length.ValueElement.Value
              ? item.Encounter.Length.ValueElement.Value
              : "",
          tinh_trang_ra_vien: this.hanleTinhTrangRaVien(item),
          danh_sach_benh: this.handleDanhSachBenh(item),
          danh_sach_benh_kem_theo: this.handleDanhSachBenh(item, true),
          danh_sach_cchn_bac_si: this.handleDanhSachCCHN(item),
        };

        arrNew.push(obj);
      });
      let this_ = this;
      arrNew = arrNew.sort(function (a, b) {
        return (
          new Date(
            b.ngay_bat_dau.substring(6, 10),
            parseInt(b.ngay_bat_dau.substring(3, 5)) - 1,
            b.ngay_bat_dau.substring(0, 2)
          ).getTime() -
          new Date(
            a.ngay_bat_dau.substring(6, 10),
            parseInt(a.ngay_bat_dau.substring(3, 5)) - 1,
            a.ngay_bat_dau.substring(0, 2)
          ).getTime()
        );
      });

      return arrNew;
    },

    //quyền bệnh nhân, tự xem detail
    fn_openModalDetail(item) {
      this.mData.dialogDetail.data = MethodService.copyObject(item);
      this.mData.dialogDetail.token = this.mData.token;
      this.mData.dialogDetail.visibleDialog = true;
      this.$store.commit("fn_reloadModalDetailHL7");
    },

    //bác sỹ xem detail
    fn_checkViewDetail(item) {
      let phoneNumber = "";
      if (Object.keys(this.mData.queryData).length > 0) {
        if (
          !this.mData.queryData.SoDienThoai &&
          this.mData.queryData.MaCSKB &&
          this.mData.queryData.MaCSKB !== item.ma_noi_kham
        ) {
          toastr.warning(
            "BN chưa khai báo số điện thoại, vui lòng xem kết quả kcb trên ứng dụng HSSK"
          );
          return;
        }
        phoneNumber = this.mData.queryData.SoDienThoai
          ? this.mData.queryData.SoDienThoai
          : "";
      }
      // let cache = this.mData.actived.filter((card) => {
      //   return (
      //     card.cardCode == this.mData.dataFormDoctor.cardCode &&
      //     card.phoneNumber == phoneNumber &&
      //     new Date().getTime() - new Date(card.time).getTime() <
      //       24 * 60 * 60 * 1000
      //   );
      // });
      let cache = this.mData.actived.filter((card) => {
        return (
          card.cardCode == this.mData.dataFormDoctor.cardCode &&
          card.phoneNumber == phoneNumber &&
          card.param &&
          card.param == this.$router.currentRoute.query.param &&
          card.EnteredOTP
        );
      });
      if (cache.length > 0) {
        this.mData.dialogDetail.data = MethodService.copyObject(item);
        this.mData.dialogDetail.cardCode = this.mData.dataFormDoctor.cardCode;

        HsskHL7Api.chiTietLanKham(
          this.mData.dialogDetail.data.id,
          this.mData.dialogDetail.cardCode,
          "hiddenMessage",
          this.mData.token
        ).then(
          (res) => {
            this.mData.dialogDetail.dataTabAll = res.result;
            this.mData.dialogDetail.visibleDialog = true;
            this.mData.dialogDetail.token = this.mData.token;
            this.$store.commit("fn_reloadModalDetailHL7");
          },
          (err) => {
            toastr.error(LanguageService.lang.c_findError);
          }
        );
      } else if (
        this.mData.queryData.MaCSKB &&
        this.mData.queryData.MaCSKB == item.ma_noi_kham
      ) {
        this.mData.dialogDetail.data = MethodService.copyObject(item);
        this.mData.dialogDetail.cardCode = this.mData.dataFormDoctor.cardCode;
        this.mData.dialogDetail.token = this.mData.token;
        this.mData.dialogDetail.visibleDialog = true;
        this.$store.commit("fn_reloadModalDetailHL7");
      } else {
        toastr.info("Bạn cần xin quyền truy cập");
        this.mData.dialogDetail.dataTabAll = null;
        this.mData.dialogCheckQuyen.visibleDialog = true;
        this.mData.item = item;
        this.fn_resetModal();
      }
    },

    fn_continue() {
      this.mData.dialogCheckQuyen.visibleDialog = false;
      this.fn_resetModal();
      this.mData.dialogDetail.visibleDialog = false;
    },

    async fn_sendCode() {
      this.fn_resetModal();
      let phoneNumber = "";
      if (Object.keys(this.mData.queryData).length > 0) {
        phoneNumber = this.mData.queryData.SoDienThoai
          ? this.mData.queryData.SoDienThoai
          : "";
      }
      try {
        let res = await HsskHL7Api.requestOtp(
          this.mData.dataFormDoctor.cardCode,
          phoneNumber,
          this.mData.token
        );
        this.mData.dataFormCheckQuyen.status = "choXacNhan";
        this.mData.dataFormCheckQuyen.mobile = res.data.result.mobile;
      } catch (error) {
        this.mData.dataFormCheckQuyen.status = "guiKhongThanhCong";
      }

      // test
      // this.mData.dataFormCheckQuyen.status = "choXacNhan";
    },

    async fn_confirmCode() {
      this.$refs["myForm"].validateField("otp", async (valid) => {
        if (!valid) {
          this.mData.dataFormCheckQuyen.status = "choXacNhan";
          try {
            let phoneNumber = "";
            if (Object.keys(this.mData.queryData).length > 0) {
              phoneNumber = this.mData.queryData.SoDienThoai;
            }
            let res = await HsskHL7Api.validateOtp(
              this.mData.dataFormDoctor.cardCode,
              phoneNumber,
              this.mData.dataFormCheckQuyen.otp,
              this.mData.token
            );
            if (res && res.data && res.data.result) {
              this.mData.dataFormCheckQuyen.status = "xacNhanThanhCong";
              this.mData.actived.push({
                cardCode: this.mData.dataFormDoctor.cardCode,
                phoneNumber: phoneNumber,
                time: new Date().getTime(),
                param: this.$router.currentRoute.query.param,
                EnteredOTP: true,
              });
              let cache = {};
              if (window.localStorage.getItem("activedOTPHis")) {
                cache = JSON.parse(
                  window.localStorage.getItem("activedOTPHis")
                );
              }
              cache["bs_biin"] = this.mData.actived;
              window.localStorage.setItem(
                "activedOTPHis",
                JSON.stringify(cache)
              );
              return;
            }
            this.mData.dataFormCheckQuyen.status = "xacNhanKhongThanhCong";
          } catch (error) {
            this.mData.dataFormCheckQuyen.status = "xacNhanKhongThanhCong";
          }

          // test
          // this.mData.dataFormCheckQuyen.status = "xacNhanThanhCong";
        }
      });
    },

    fn_sendCodeAgain() {
      this.fn_resetModal();
    },

    fn_backSendCode() {
      this.fn_resetModal();
    },

    fn_resetModal() {
      this.mData.dataFormCheckQuyen.status = "chuaGui";
      this.mData.dataFormCheckQuyen.mobile = "";
    },
    fn_viewPacs(url) {
      // this.mData.urlPacs = url;
      // this.mData.showPacs = !this.mData.showPacs;
      window.open(url);
    },
    fn_changeGender(gender) {
      switch (gender) {
        case "M":
          return "Nam";
          break;
        case "F":
          return "Nữ";
          break;
        default:
          return "Khác";
          break;
      }
    },
    fn_formatDate(date) {
      return MethodService.formatDate(date, "date");
    },
    hanleTinhTrangRaVien(item) {
      let listTTRV = [];
      if (item.Observations.length > 0) {
        item.Observations.forEach((element) => {
          let obj = {
            idTinhTrangRaVien: "",
            textTinhTrangRaVien: "",
          };
          if (
            element.Code &&
            element.Code.Coding &&
            element.Code.Coding.length > 0 &&
            element.Code.Coding[0].CodeElement &&
            element.Code.Coding[0].CodeElement.Value &&
            element.Code.Coding[0].CodeElement.Value == "52523-8"
          ) {
            obj.idTinhTrangRaVien =
              element.Identifier &&
              element.Identifier.length > 0 &&
              element.Identifier[0].ValueElement &&
              element.Identifier[0].ValueElement.Value
                ? element.Identifier[0].ValueElement.Value
                : "";
            obj.textTinhTrangRaVien =
              element.Text && element.Text.Div ? element.Text.Div : "";
          }
          listTTRV.push(obj);
        });
      }
      return listTTRV;
    },
    handleDanhSachBenh(item, isBenhKemTheo) {
      let listBenh = [];
      if (
        item.Condition &&
        item.Condition.Code &&
        item.Condition.Code.Coding &&
        item.Condition.Code.Coding.length > 0
      ) {
        item.Condition.Code.Coding.forEach((element) => {
          if (element.DisplayElement && element.DisplayElement.Value) {
            listBenh.push(element.DisplayElement.Value);
          }
        });
      }
      if (isBenhKemTheo && listBenh.length > 0) {
        listBenh.shift();
      }
      return listBenh;
    },
    handleDanhSachCCHN(item) {
      let listCCHN = [];
      if (
        item.Encounter &&
        item.Encounter.Participant &&
        item.Encounter.Participant.length > 0
      ) {
        item.Encounter.Participant.forEach((element) => {
          if (element.ElementId) {
            let arr = element.ElementId.split(";");
            if (arr.length > 0) {
              arr.forEach((item) => {
                listCCHN.push(item.trim());
              });
            }
          }
        });
      }
      let dataFillter = [];
      if (listCCHN.length > 0) {
        listCCHN.forEach((item, index) => {
          let fillter = dataFillter.find((el) => el == item);
          if (!fillter) {
            dataFillter.push(item);
          }
        });
      }
      return dataFillter;
    },
    countDownTime(distance) {
      // let now = new Date().getTime();

      // // Find the distance between now and the count down date
      // let distance = countDownDate - now;

      // Time calculations for hours, minutes and seconds

      var hours = 0;
      let minutes = 0;
      let seconds = 0;
      if(distance<60*10*1000){
        this.warningColor = true;
      }
      while (true)
        if (distance >= 1000 * 60 * 60) {
          hours++;
          distance -= 1000 * 60 * 60;
        } else if (distance >= 1000 * 60) {
          minutes++;
          distance -= 1000 * 60;
        } else if (distance >= 1000) {
          seconds++;
          distance -= 1000;
        } else break;

      // Format output-string
      var hours = hours < 10 ? "0" + hours : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;
      return `${hours}:${minutes}:${seconds}`;
    },
  },

  //run after render view
  created() {},
  mounted() {
    this.fn_initData();
  },
};
</script>

<style scoped>
.red{
  color: red;
}
.black{
  color: black;
}
</style>